import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { useLocalForage } from 'contexts/LocalForage'
import Section from 'components/Section'
import Wrapper from 'components/Wrapper'
import VuseRewardsPerks from 'components/AccountCreation/CreationFormSecondStep/VuseRewardsPerks'
import CreationForm from './CreationForm'
import { SyncData } from 'api/users'
import toast from 'react-hot-toast'
import CameraScan from 'components/PatronScan/CameraScan'
import { IS_PATRON_SCAN_FEATURE_ENABLED } from 'utils/constants'
import Disclaimer from 'components/AccountCreation/CreationFormSecondStep/Disclaimer'

const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
`

const FormContainer = styled.div`
  width: 100%;
`
const CameraScanWrap = styled.div`
  position: absolute;
  right: 0%;
  top: 20px;
`
const CreationFormSecondStep = () => {
  const { getStoredItem } = useLocalForage()
  const [isDarkMarket, setIsDarkMarket] = useState(true)

  const [isShowScanIcon, setIsShowScanIcon] = useState(false)

  useEffect(() => {
    const setDarkMarket = async () => {
      const darkMarket = await getStoredItem('darkMarket')
      setIsDarkMarket(darkMarket)
    }

    setDarkMarket()
  }, [])

  const showScanIcon = useCallback((value) => {
    setIsShowScanIcon(value)
  }, [])

  useEffect(() => {
    function checkOnlineStatus() {
      if (navigator.onLine) {
        toast.success('online')
        SyncData()
      } else {
        toast.success('Offline, will sync when online')
      }
    }
    // Listen for online event
    window.addEventListener('online', checkOnlineStatus)
    window.addEventListener('offline', checkOnlineStatus)

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('online', checkOnlineStatus)
      window.removeEventListener('offline', checkOnlineStatus)
    }
  }, [])
  return (
    <>
      {IS_PATRON_SCAN_FEATURE_ENABLED && isShowScanIcon && (
        <CameraScanWrap>
          <CameraScan />
        </CameraScanWrap>
      )}

      <Section title={'NOT A MEMBER? EARN POINTS, UNLOCK REWARDS'} hasSubtitle={!isDarkMarket}>
        <Wrapper>
          <Content>
            <VuseRewardsPerks />

            <FormContainer>
              <CreationForm showScanIcon={showScanIcon} />
            </FormContainer>
            <br />
            <br />
            <Disclaimer />
          </Content>
        </Wrapper>
      </Section>
    </>
  )
}

export default CreationFormSecondStep
